'use client'

import React from 'react'
import Providers from './providers'

interface ClientProvidersProps {
  children: React.ReactNode
}

export const ClientProviders: React.FC<ClientProvidersProps> = ({ children }) => {
  return (
    <Providers>
      {children}
    </Providers>
  )
} 